import { readServerFailure } from "common-fe";

// #2749 -- the reason a completeScoreSheet / confirmScoreSheetMarks 409 (or any
// other score-api 4xx) names, in the words an admin reads. Built on common-fe's
// shared readServerFailure (the one place the generated client's error body is
// unwrapped, since the interceptor rewrites err.message to "Server Error"), so
// no call site reads err.response itself.
//
// Order: a sheet_incomplete 409 names WHICH half of the sheet is blank, off the
// field score-api already returns (movementScores | collectives); any other
// code uses score-api's own curated message (score-common ERROR_MESSAGES,
// #2809): panel_not_fully_signed, missing_signature, marks_confirmed_frozen
// and the rest. With no usable body (a network error, a 5xx) it returns null so
// the caller keeps its own generic string. Every key is a static literal.
export function gateFailureReason(err, t) {
  const { code, message, data } = readServerFailure(err);
  if (code === "sheet_incomplete") {
    if (data?.field === "movementScores") return t("rideEditor.gateIncompleteMovements");
    if (data?.field === "collectives") return t("rideEditor.gateIncompleteCollectives");
  }
  return message;
}

// HOTFIX card 3689 (TRI-336) -- the sheet editor's Commit 409. Same unwrapping as
// gateFailureReason, but a sheet_incomplete here also covers the rider who did not
// finish the test (withdrew mid-test), so the message names the blank half AND
// points at Set Outcome. Returns null when there is no usable body.
export function commitFailureReason(err, t) {
  const { code, message, data } = readServerFailure(err);
  if (code === "sheet_incomplete") {
    if (data?.field === "movementScores") return t("rideEditor.commitIncompleteMovements");
    if (data?.field === "collectives") return t("rideEditor.commitIncompleteCollectives");
  }
  return message;
}

// #3723 -- true when a commit 409 is the blank-marks refusal, whose fix is a button
// (Discard changes / Set Outcome) rather than more reading.
export function isSheetIncompleteFailure(err) {
  return readServerFailure(err).code === "sheet_incomplete";
}
